/* eslint-disable react/forbid-prop-types */
import React, { useContext, useEffect } from 'react';

import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';

import { TabsContext } from '../../context/tabs/tabsContext';

import { getPerfiladorActiveTab } from '../../storage';

import { PerfiladorHeaderTabs } from './components/PerfiladorHeaderTabs';
import { PerfiladorBodyTabs } from './components/PerfiladorBodyTabs';
import useStyles from './useStyles';

import { DEFAULT_PERFILADOR_LANDING_CONFIG, PERFILADOR_DEFAULT_TABS } from '../../constants';

export const Perfilador = ({
  buttonTitle,
  onSubmit,
  handleChangeActiveTab,
  showFooter,
  variant,
  dataTabs,
  footerText,
}) => {
  const { initTabs } = useContext(TabsContext);
  const classes = useStyles();

  useEffect(() => {
    const activeTab = getPerfiladorActiveTab();
    initTabs({
      tabs: dataTabs,
      default: activeTab || dataTabs[0].value,
      variant,
    });
  }, []);

  return (
    <Box className={classes.containerPerfilador}>
      <PerfiladorHeaderTabs
        handleChangeActiveTab={handleChangeActiveTab}
        showFooter={showFooter}
      />
      <PerfiladorBodyTabs
        onSubmit={onSubmit}
        buttonTitle={buttonTitle}
        showFooter={showFooter}
        footerText={footerText}
      />
    </Box>
  );
};

Perfilador.propTypes = {
  buttonTitle: PropTypes.string,
  onSubmit: PropTypes.func,
  handleChangeActiveTab: PropTypes.func,
  showFooter: PropTypes.bool,
  variant: PropTypes.string,
  dataTabs: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
  })),
  footerText: PropTypes.string,
};

Perfilador.defaultProps = {
  buttonTitle: DEFAULT_PERFILADOR_LANDING_CONFIG.buttonText,
  showFooter: false,
  onSubmit: () => {},
  handleChangeActiveTab: () => {},
  variant: '',
  footerText: DEFAULT_PERFILADOR_LANDING_CONFIG.footerText,
  dataTabs: PERFILADOR_DEFAULT_TABS,
};
